module.exports = __webpack_public_path__ + "static/media/star-color.3aeea8e7.svg";